import React, { Component } from 'react'
import arraysEqual from './../../lib/arraysEqual'
import Option from './Option'

class BranchSelect extends Component {

  static defaultProps = {
    branchIds: [],
  }

  shouldComponentUpdate = (nextProps) => {
    return nextProps.value != this.props.value ||
      !arraysEqual(nextProps.branchIds, this.props.branchIds)
  }

  onChange = (e) => {
    var selectedBranchId = e.target.value
    //if (selectedBranchId == '')
    //  selectedBranchId = null
    this.props.onChange(selectedBranchId)
  }

  render = () => {
    const { branchIds, value, className } = this.props
    return <select
      onChange={this.onChange}
      value={value || ''}
      className={className}
    >
      {branchIds.map(id => <Option
        id={id}
        key={id}
      />)}
    </select>
  }
}

export default BranchSelect



// WEBPACK FOOTER //
// ./src/modules/BranchSelect/BranchSelect.js